export default __webpack_public_path__ + "images/72d2b4187a7dba485fa4a1f951317bce.svg";